// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ChangelogRouteImport } from './routes/changelog'
import { Route as IndexRouteImport } from './routes/index'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ChangelogRoute = ChangelogRouteImport.update({
            id: '/changelog',path: '/changelog',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ChangelogRoute: ChangelogRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)